<template>
  <div class="sidebar-ct">
    <div class="header">
      <div class="header-title">
        <icon glyph="navigation-content" size="18" />
        <span>
          {{ $t('CampaignForm_Preview_Sidebar_Title') }}
        </span>
      </div>
    </div>
    <div class="main-ct">
      <div class="campaign-config-section">
        <sidebar-variant-selector
          v-if="model.ab"
          @variant-change="changeVariant($event)"
          :model="model"
        />
        <sidebar-workflow-email-selector
          v-if="model.workflow"
          @workflow-email-change="$emit('workflow-email-change', $event)"
          :model="model"
          :variant-key="variant"
        />
        <sidebar-language-selector
          v-if="model.languages_multi"
          @language-change="changeLanguage"
          :model="model"
        />
        <preview-content-data-tabs
          :key="variant + language"
          @data-change="$emit('data-change', $event)"
          :model="model"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SidebarLanguageSelector from '@/modules/campaign-manage/components/preview/SidebarLanguageSelector.vue'
import SidebarVariantSelector from '@/modules/campaign-manage/components/preview/SidebarVariantSelector.vue'
import PreviewContentDataTabs from '@/modules/campaign-manage/components/preview/content-data-tabs/PreviewContentDataTabs.vue'
import SidebarWorkflowEmailSelector from '@/modules/campaign-manage/components/preview/SidebarWorkflowEmailSelector.vue'

export default {
  name: 'PreviewContentSidebar',

  components: {
    SidebarWorkflowEmailSelector,
    PreviewContentDataTabs,
    SidebarVariantSelector,
    SidebarLanguageSelector
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      variant: 'A',
      language: 'en'
    }
  },

  methods: {
    changeVariant(event) {
      this.variant = event
      this.$emit('variant-change', event)
    },

    changeLanguage(event) {
      this.language = event
      this.$emit('language-change', event)
    }
  }
}
</script>

<style scoped>
.sidebar-ct {
  display: flex;
  flex-direction: column;
  //height: 100vh; @todo investigate and fix the height issue
  width: 350px;
  min-width: 350px;
  border-right: 1px solid #ebeef5;
}

.main-ct {
  padding: 20px 17px 0;
}

.header {
  display: flex;
  justify-content: space-between;
  height: 60px;
  border-bottom: 1px solid #ebeef5;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  line-height: 28px;
  font-weight: 600;
  color: #4b515f;
  padding: 0 21px;
}

.campaign-config-section {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/preview/PreviewContentSidebar.vue